import React from "react";
import {Card, Space, Table, Tag} from "antd";
import {ColumnsType} from "antd/lib/table/interface";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {HealthCheck, HealthCheckGroup} from "../../../../models/health-checker/health-checker";
import {useTranslate} from "../../../../hooks/translate.hook";

interface DashboardGroupProps {
    group: HealthCheckGroup;
    columns: ColumnsType<HealthCheck>;
}

export const DashboardGroup: React.FC<DashboardGroupProps> = ({group, columns}) => {
    const t = useTranslate();
    const failedChecksCount = group.checks.filter((check) => check.status === "not_ok").length;

    return (
        <Card
            className="health-center-dashboard__group-card"
            title={
                <Space>
                    <FontAwesomeIcon icon={["fas", "cubes"]} />
                    <span>{group.name}</span>
                </Space>
            }
            extra={
                <Space wrap>
                    <Tag>{t("HEALTH-CENTER.DASHBOARD.CHECKS-COUNT", {
                        count: group.checks.length,
                        defaultValue: "{{count}} checks",
                    })}</Tag>
                    {failedChecksCount > 0 ? (
                        <Tag color="error">
                            {t("HEALTH-CENTER.DASHBOARD.FAILED-COUNT", {
                                count: failedChecksCount,
                                defaultValue: "{{count}} failed",
                            })}
                        </Tag>
                    ) : (
                        <Tag color="success">
                            {t("HEALTH-CENTER.DASHBOARD.STATUS.OK", {defaultValue: "OK"})}
                        </Tag>
                    )}
                </Space>
            }
        >
            <Table<HealthCheck>
                columns={columns}
                dataSource={group.checks}
                rowKey={(check) => `${group.id}-${check.checkerName}`}
                rowClassName={(check) => check.status === "not_ok" ? "health-center-dashboard__table-row--failed" : ""}
                pagination={false}
                size="middle"
                scroll={{x: 1140}}
            />
        </Card>
    );
};
